// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import { PATH_MANAGEMENT } from '../../../routes/paths';
import { PermissionPath } from '../../../components/permission/PermissionPath';
import { useParams } from 'react-router';
import { can } from 'src/components/permission/Permission';
import useAuth from 'src/hooks/useAuth';

export const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  discount: getIcon('ic_discount_circle'),
  advertisement: getIcon('ic_advertising'),
  invoice: getIcon('ic_order'),
  product_category: getIcon('ic_category'),
  setting: getIcon('ic_settings'),
  role: getIcon('ic_permission'),
  settlement: getIcon('ic_financial'),
  price: getIcon('ic_price'),
  shop: getIcon('ic_shop'),
  courier: getIcon('ic_courier'),
  comment: getIcon('ic_comment'),
  further: getIcon('ic_further'),
  geoJson: getIcon('ic_geoJson'),
  logo: getIcon('ic_logo'),
  workingHours: getIcon('ic_workingHours'),
  address: getIcon('ic_address'),
  calendar: getIcon('ic_calendar'),
  invoice: getIcon('ic_invoice'),
  comment: getIcon('ic_comment'),
  setting: getIcon('ic_setting'),
  bank: getIcon('ic_bank'),
  courier: getIcon('ic_courier'),
  shop_user_block: getIcon('ic_user_block'),
  discountCode: getIcon('ic_discount-outline'),
  bestSellingItems: getIcon('ic_best-selling-items'),
};

const ShopNavConfig = () => {
  const { rootShopId } = useParams();
  const { user } = useAuth();
  const isAdminOrSupporter = user.roles.some((role) => ['admin', 'supporter'].includes(role.name));
  return [
    {
      subheader: 'مدیریت واحد',
      items: [
        ...(isAdminOrSupporter
          ? [
              {
                title: 'بازگشت',
                path: PATH_MANAGEMENT.management.shops,
              },
            ]
          : []),

        {
          title: 'سفارشات',
          path: PATH_MANAGEMENT.management.editShop.shopInvioce(rootShopId),
          icon: ICONS.invoice,
          permissions: [PermissionPath.shop.invoice.index],
        },
        {
          title: 'محصولات',
          path: PATH_MANAGEMENT.management.editShop.product(rootShopId),
          icon: ICONS.product_category,
          permissions: [PermissionPath.shop.productCategory.index],
        },
        {
          title: 'افزایش فروش',
          path: PATH_MANAGEMENT.management.editShop.increaseSales(rootShopId),
          icon: ICONS.analytics,
        },
        {
          title: 'نظرات',
          path: PATH_MANAGEMENT.management.editShop.commentShop(rootShopId),
          icon: ICONS.comment,
          permissions: [PermissionPath.shop.comment.index],
        },

        {
          title: 'ساعات کاری',
          path: PATH_MANAGEMENT.management.editShop.workingHours(rootShopId),
          icon: ICONS.workingHours,
          permissions: [PermissionPath.shop.workingHour.index],
        },
        {
          title: 'تعطیلات',
          path: PATH_MANAGEMENT.management.editShop.holidays(rootShopId),
          icon: ICONS.calendar,
          permissions: [PermissionPath.shop.holiday.index],
        },

        {
          title: 'شماره حساب تسویه',
          path: PATH_MANAGEMENT.management.editShop.shopBankAccount(rootShopId),
          icon: ICONS.bank,
          permissions: [PermissionPath.shop.bankAccount.index],
        },

        {
          title: 'تراکنش ها',
          path: PATH_MANAGEMENT.management.editShop.showTransactions(rootShopId),
          icon: ICONS.settlement,
          permissions: [PermissionPath.shop.showTransactionsOfRialsWallet],
        },
        {
          title: 'گزارش اقلام پر فروش',
          path: PATH_MANAGEMENT.management.editShop.BestSellingItems(rootShopId),
          icon: ICONS.bestSellingItems,
          permissions: [PermissionPath.shop.invoice.topInvoiceitems],
        },

        {
          title: 'تخفیف پیک',
          path: PATH_MANAGEMENT.management.editShop.discountShopCourier(rootShopId),
          icon: ICONS.courier,
          permissions: ['shop.get-courier-discount'],
        },
        {
          title: 'تخفیف ها',
          path: PATH_MANAGEMENT.management.editShop.discountShop(rootShopId),
          icon: ICONS.discountCode,
          permissions: ['shop.discountcode.index'],
        },
        {
          title: 'مدیریت کارمندان',
          path: PATH_MANAGEMENT.management.editShop.users(rootShopId),
          icon: ICONS.user,
          children: [
            {
              title: 'کارمندان',
              path: PATH_MANAGEMENT.management.editShop.users(rootShopId),
              icon: ICONS.user,
              permissions: [PermissionPath.shop.user.index],
            },
            ,
            {
              title: 'کاربران مسدود شده',
              path: PATH_MANAGEMENT.management.editShop.shopBlockUser(rootShopId),
              icon: ICONS.shop_user_block,
              permissions: [PermissionPath.shop.userBlock.index],
            },

            {
              title: 'نقش ها',
              path: PATH_MANAGEMENT.management.editShop.roles(rootShopId),
              icon: ICONS.role,
              permissions: [PermissionPath.shop.role.index],
            },
          ],
        },
        {
          title: 'تنظیمات',
          path: PATH_MANAGEMENT.management.editShop.general(rootShopId),
          icon: ICONS.setting,
          children: [
            {
              title: 'عمومی',
              path: PATH_MANAGEMENT.management.editShop.general(rootShopId),
              icon: ICONS.dashboard,
              permissions: [PermissionPath.shop.index],
            },
            {
              title: 'لوگو و سربرگ',
              path: PATH_MANAGEMENT.management.editShop.logo(rootShopId),
              icon: ICONS.logo,
              permissions: [PermissionPath.shopSettings.logo],
            },
            {
              title: 'اطلاعات تکمیلی',
              path: PATH_MANAGEMENT.management.editShop.further(rootShopId),
              icon: ICONS.further,
            },
            {
              title: 'آدرس',
              path: PATH_MANAGEMENT.management.editShop.address(rootShopId),
              icon: ICONS.address,
              permissions: [PermissionPath.shop.address.index],
            },
            {
              title: 'مناطق پوشش دهی',
              path: PATH_MANAGEMENT.management.editShop.geoJson(rootShopId),
              icon: ICONS.geoJson,
              permissions: [PermissionPath.shop.geofence.index],
            },
            {
              title: 'اکانت کاربری',
              path: PATH_MANAGEMENT.management.editShop.accountUser(rootShopId),
              icon: ICONS.geoJson,
            },
            {
              title: 'راهنمای برنامه ی ویندوزی',
              path: PATH_MANAGEMENT.management.editShop.WindowsProgram(rootShopId),
              icon: ICONS.geoJson,
            },
          ],
        },
      ],
    },
  ];
};

export default ShopNavConfig;
